import { ChargeBlock as ChargeBlockModel } from '~/models/blocks/charge-block.model';

export const CHARGE_BLOCK_PROPERTIES = [
    'payment_method_types',
    'allow_autopay',
    'allow_gratuity',
    'gratuity_type'
];

export interface MobileChargeBlock extends ChargeBlockModel {
    isRecurring: boolean;
    isRecurringUnderMinimumDays: boolean;
}
